import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, Tabs,Tab, TableCell, Grid, Box, TableContainer, TableHead, TableRow, TextField, Button, Paper, IconButton,makeStyles,
  Typography, FormControl
} from '@material-ui/core';
import { DeleteOutline, PlusOne, Print, Search } from '@material-ui/icons';
import instance from 'api/globalaxios';
import { format, isValid } from 'date-fns';
import CircularCenteredLoader from 'features/common/CircularCenteredLoader';
import Swal from 'sweetalert2';
import { formatDate } from 'utils';
import DateRangePickerTDSAT from 'features/Tdsat/DateRangePickerTDSAT';
import fileDownload from 'js-file-download';
import DatePickerTDSAT from 'features/Tdsat/components/DatePickerTDSAT';
import { Pagination } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
		padding: '1.5rem',
    width: '100%',
    boxSizing: 'border-box',
	},
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  searchField: {
    marginRight: theme.spacing(1),
    flexGrow: 1,
    borderRadius: '8px',
  },
  table: {
    minWidth: 650,
    width: '100%',
    maxWidth: '100%'
  },
  noDefect: {
    color: 'green',
  },
  pagination: {
    marginTop: theme.spacing(2),
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  datePickers: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexGrow: 1
  },
  noBorders: {
    border: 'none',
    fontSize: '13px',
    
  },
  noBordersTitle: {
    border: 'none',
    fontSize: '15px',
    fontFamily: 'Satoshi-Bold',
  },
  buttonPrint: {
    borderRadius: '8px',
    border: '1px solid var(--BG-Color-1, #AAAFB9)',
    background: '#fff',
    padding: '9px 14px',
    minWidth: 'fit-content',
  },
  tableRow: {
    '& tr': {
      marginBottom: '8px !important'  
    },
    '& th, & td': { 
      padding: '20px !important',  
    },
    border: '1px solid #E5E5E5',
    background: '#fff',
  },
  tabContainer: {
    marginBottom: theme.spacing(2),
  },
  titleTop: {
    fontSize: '20px',
    fontWeight: 700,
  },
  smallInput: {
    '& input': {
      padding: '8px', // reduce vertical & horizontal padding
      fontSize: '0.85rem',
    },
  }
}));

const BenchTable = ({onFileNewNotice, onShowBenchPriority}) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 10;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [countPagination, setCountPagination] = useState(0);
  const [listingDate, setListingDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false); 

  const tabTypes = ['notice', 'dasti_notice', 'ea/ma/other'];

  useEffect(() => {
    fetchScrutinyReportData();
  },[activeTab])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchScrutinyReportData(listingDate, newPage); // Update data on page change
  };

  const handlePrintReport = async () => {
    if (!listingDate) {
      Swal.fire({
        title: "Error",
        text: "Please select date and then Submit.",
        icon: "error"
      });
      return;
    }
    try {
      const response = await instance.get(`tdsat/bench_report/generate?type=main_cases&date=${format(listingDate, 'dd-MM-yyyy')}`, {responseType: 'blob'});
      fileDownload(
        response.data,
        `BenchReport.pdf`
      );
      Swal.fire({
          title: "Print Slip",
          text: "Report Downloaded Successfully",
          icon: "success"
        });
    }catch (error){
        console.error("There was an error fetching the case data!", error);
    }
  };

  const handleDeleteBench = async (benchId) => {
    try {
      const response = await instance.patch(`tdsat/bench/${benchId}/`);
      Swal.fire({
          title: "Delete",
          text: "Deleted Bench Successfully",
          icon: "success"
        });
      fetchScrutinyReportData();
    }catch (error){
        console.error("There was an error fetching the case data!", error);
    }
  };

  const handleSubmit = () => {
    //  if (!listingDate) {
    //   Swal.fire({
    //     title: "Error",
    //     text: "Please select listing date and then submit",
    //     icon: "error"
    //   });
    //   return;
    // }
    fetchScrutinyReportData(listingDate); 
  };

  const fetchScrutinyReportData = async (listingDate = new Date(), page = 1) => {
    setLoading(true); 
    try {
      const params = {
        date: listingDate ? format(listingDate, 'dd-MM-yyyy') : '',
        page: page > 1 ? page : 1,
      };
      const response = await instance.get('/tdsat/bench/', { params });
      setFilteredData(response?.data?.results || []);
      let count = response?.data?.count || 0;
      let total = Math.ceil(count / PAGE_SIZE);
      setCountPagination(total);
    } catch (error) {
      console.error('There was an error fetching the case data!', error);
    }
    setLoading(false);
  };

  const handleDateInput = (value) => {
    setListingDate(value)
  }

  const handleUpdateCauselistHeader = async (e, rowId) => {
    try {
        await instance.put(`/tdsat/bench/${rowId}/`, {
          time: e.target.value,
        });
        Swal.fire({
          icon: 'success',
          title: 'Updated',
          text: 'Causelist Header updated successfully.',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Update failed', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to update Causelist Header.',
        });
      }

  }

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Grid container alignItems="center" style={{justifyContent: 'space-between'}}>
          <Grid item>
            <Typography className={classes.titleTop}>Bench Composition</Typography>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={onFileNewNotice}
              style={{ marginTop: '20px',  marginRight: '10px', borderRadius: '8px' }}
              endIcon={'+'}
            >
              Create Bench
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={onShowBenchPriority}
                style={{ marginTop: '20px', marginRight: '10px', borderRadius: '8px' }}
                endIcon={'+'}
              >
                Purpose Priority
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div className={classes.searchContainer}>
        <Grid item xs={12}>
          <FormControl fullWidth margin="none" variant="outlined">
            <DatePickerTDSAT
              size='small'
              date={listingDate}
              setDate={handleDateInput}
              label="Date"
            />
          </FormControl>
        </Grid>

        {/* Submit Button */}
        <Button size='small' onClick={handleSubmit} style={{ marginLeft: '10px' }} className={classes.buttonPrint}>
          Submit
        </Button>

        {/* Print Button */}
        <Button size='small' onClick={handlePrintReport} style={{ marginLeft: '10px' }} className={classes.buttonPrint}>
          <Print /> Print Report
        </Button>
      </div>
      
      {loading ? (
        <div className={classes.loader}>
          <CircularCenteredLoader />
        </div>
      ) : (
        <>
          <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.noBordersTitle}>Sr. No.</TableCell>
                <TableCell className={classes.noBordersTitle}>Bench Number</TableCell>
                <TableCell className={classes.noBordersTitle}>Court Number</TableCell>
                <TableCell className={classes.noBordersTitle}>Listing Date</TableCell>
                <TableCell className={classes.noBordersTitle}>Causelist Header</TableCell>
                <TableCell className={classes.noBordersTitle}>Justice</TableCell>
                <TableCell className={classes.noBordersTitle}>Presiding</TableCell>
                <TableCell className={classes.noBordersTitle}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.length > 0 ? (
                filteredData.map((row, index) => (
                  <TableRow key={index} className={classes.tableRow}>
                  <TableCell>{(page - 1) * rowsPerPage + (index + 1)}</TableCell>
                  <TableCell className={classes.noBorders}>{row?.bench_number}</TableCell>
                  <TableCell className={classes.noBorders}>{row?.court_number}</TableCell>
                  <TableCell className={classes.noBorders}>{isValid(row?.listing_date_timestamp) ? formatDate(row?.listing_date_timestamp) : row?.listing_date_timestamp}</TableCell>
                  <TableCell className={classes.noBorders}>
                    <TextField
                      className={classes.smallInput}
                      variant="outlined"
                      size="small"
                      margin='dense'
                      value={row?.causelist_header || ''}
                      onChange={(e) => {
                        const updatedData = [...filteredData];
                        updatedData[index].causelist_header = e.target.value;
                        setFilteredData(updatedData);
                      }}
                      fullWidth
                      onBlur={(e) => handleUpdateCauselistHeader(e, row?.id)}
                    />
                  </TableCell>
                  <TableCell className={classes.noBorders}>
                    {row?.judges?.map((judge, judgeIndex) => (
                      <span key={judgeIndex}>
                        {judge?.name}
                        {judgeIndex < row.judges.length - 1 && <br />}
                      </span>
                    ))}
                  </TableCell>
                  <TableCell className={classes.noBorders}>{row?.presiding_judge?.name}</TableCell>
                  <TableCell className={classes.noBorders} style={{cursor: 'pointer'}} onClick={()=>handleDeleteBench(row?.id)}><DeleteOutline/></TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className={classes.noBorders} align="center">
                    No Bench on this Listing Date
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          </TableContainer>
          {filteredData.length !== 0 && (
            <Box style={{padding:'16px', display: 'flex', justifyContent: 'flex-end'}}>
              <Pagination color="primary" count={countPagination} page={page} onChange={handleChangePage}/>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default BenchTable;

